export function parseRewardCampaignRules(value: any): any {
  if (typeof value === 'string') {
    try {
      return value ? JSON.parse(value) : {};
    } catch {
      return value;
    }
  }

  return value ?? {};
}

export function rewardCampaignAppliesToAllBrands(rules: any): boolean {
  const parsedRules = parseRewardCampaignRules(rules);
  const brands = parsedRules?.brands;

  if (Array.isArray(brands)) {
    return brands.length === 0;
  }

  if (typeof brands === 'string') {
    return brands.trim() === '';
  }

  return !brands;
}
